/* eslint-disable no-empty-pattern */
import { createUseStyles } from 'react-jss';
import { defaultFonts } from '@wds/utils';

const useStyles = createUseStyles((theme) => {
  const { borderColor, card, spacing } = theme;

  return {
    wrenchCard: ({ selected, interactive }) => ({
      ...defaultFonts(theme),

      backgroundColor: card.bgColor,
      border: card.border,
      borderRadius: card.borderRadius,
      boxShadow: card.boxShadow,
      // property will get overwritten, but needed the `cursor: pointer`
      // when interactive
      borderColor: card.borderColor,
      ...(interactive && {
        '&:hover, &:focus': {
          borderColor: borderColor.hover,
          cursor: 'pointer',
        },
      }),
      ...(selected && {
        borderColor: borderColor.active,
        '&:hover, &focus': {
          borderColor: borderColor.active,
        },
      }),
    }),

    wrenchCardHeader: ({ noRule }) => {
      return {
        ...(noRule
          ? { borderBottom: 'none' }
          : { borderBottom: '1px solid #EDEEEE' }),
        boxSizing: 'border-box',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '0',
        padding: [spacing[4], spacing[5]],
        minHeight: '72px',
      };
    },

    wrenchCardBody: () => ({
      padding: card.padding,
    }),

    wrenchCardAddon: () => ({
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      minHeight: '40px',
      margin: [0, 0, 'auto', spacing[4]],
      float: 'right',
    }),
  };
});

export default useStyles;
